/* eslint-disable react/prop-types */
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  ResponsiveContainer,
} from "recharts";
import "./customChart.css";

const CustomBarChart = ({ data, height = 280, uvDataKey, pvDataKey }) => {
  const formatYTick = (value) => {
    if (value >= 1_000_000_000_000) return (value / 1_000_000_000_000).toFixed(1) + "T";
    if (value >= 1_000_000_000)     return (value / 1_000_000_000).toFixed(1) + "B";
    if (value >= 1_000_000)         return (value / 1_000_000).toFixed(1) + "M";
    if (value >= 1_000)             return (value / 1_000).toFixed(1) + "K";
    return value;
  };

  const formatXTick = (value) => {
    const maxLength = 10;
    if (!value) return "";
    return value.length > maxLength ? value.substring(0, maxLength) + "…" : value;
  };

  const renderCustomLabel = ({ x, y, width, value }) => {
    let fillColor = "#dc3545"; // red < 60%
    if (value >= 80)      fillColor = "#28a745"; // green
    else if (value >= 60) fillColor = "#ffc107"; // yellow

    return (
      <g>
        <circle cx={x + width / 2} cy={y - 10} r={9} fill={fillColor} />
        <text
          x={x + width / 2}
          y={y - 10}
          fill="#fff"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="8"
        >
          {`${value}%`}
        </text>
      </g>
    );
  };

  return (
    <div>
      {/* ResponsiveContainer fills parent width automatically */}
      <ResponsiveContainer width="100%" height={height}>
        <BarChart
          data={data}
          margin={{ top: 16, right: 10, left: 0, bottom: 4 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="name"
            tickFormatter={formatXTick}
            tick={{ fontSize: 10 }}
            interval={0}
            angle={data && data.length > 4 ? -30 : 0}
            textAnchor={data && data.length > 4 ? "end" : "middle"}
            height={data && data.length > 4 ? 50 : 30}
          />
          <YAxis
            tickFormatter={formatYTick}
            yAxisId="left"
            tick={{ fontSize: 10 }}
            width={45}
          />
          <YAxis
            tickFormatter={(v) => `${v}%`}
            orientation="right"
            yAxisId="right"
            tick={{ fontSize: 10 }}
            width={35}
          />
          <Tooltip formatter={formatYTick} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar yAxisId="left" dataKey={uvDataKey} fill="#5887B8" radius={[3, 3, 0, 0]} />
          <Bar yAxisId="left" dataKey={pvDataKey} fill="#F68332" radius={[3, 3, 0, 0]}>
            <LabelList dataKey="Performance" content={renderCustomLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <div className="custom-legend">
        <div><span className="green"></span>Performance 80%+</div>
        <div><span className="yellow"></span>Performance 60–80%</div>
        <div><span className="red"></span>Performance &lt; 60%</div>
      </div>
    </div>
  );
};

export default CustomBarChart;
